import $ from 'jquery'

let isSyncingNumber = false

const getRangeProgress = (input) => {
	const min = parseFloat(input.min) || 0
	const max = parseFloat(input.max) || 100
	const val = parseFloat(input.value) || min
	const pct = max === min ? 0 : ((val - min) / (max - min)) * 100
	return pct + '%'
}

const updateRangeStyle = ($input) => {
	$input.css('--form-range-progress', getRangeProgress($input[0]))
}

const getNfFieldModel = ($number) => {
	if (typeof window.Backbone === 'undefined' || !window.Backbone.Radio) {
		return null
	}

	const fieldId = ($number.attr('id') || '').replace(/^nf-field-/, '')
	if (!fieldId) {
		return null
	}

	try {
		return window.Backbone.Radio.channel('fields').request('get:field', fieldId)
	} catch {
		return null
	}
}

const syncNumberFieldValue = ($number, nextVal) => {
	const input = $number[0]
	if (!input || isSyncingNumber) {
		return
	}

	isSyncingNumber = true

	const value = String(nextVal)
	const fieldModel = getNfFieldModel($number)

	if (fieldModel && typeof fieldModel.set === 'function') {
		fieldModel.set('value', value)
	}

	input.value = value
	$number.val(value)
	$number.trigger('change')

	isSyncingNumber = false
}

const syncFormNumberSlidersInScope = (context) => {
	const $scope = context ? $(context) : $(document)

	$scope.find('.field-wrap.field-slider--enhanced, .number-wrap.field-slider--enhanced').each(function () {
		const $fieldWrap = $(this)
		const $number = $fieldWrap.find('input[type="number"]').first()
		const $range = $fieldWrap.find('.form-slider__range').first()

		if (!$number.length || !$range.length) {
			return
		}

		const nextVal = parseFloat($range.val())
		syncNumberFieldValue($number, nextVal)
	})
}

const copyModifierClasses = ($from, $to) => {
	const modifierPattern = /^field-slider--/
	;(($from.attr('class') || '').split(/\s+/)).forEach((className) => {
		if (modifierPattern.test(className)) {
			$to.addClass(className)
		}
	})
}

const collectFieldWraps = ($scope) => {
	const wraps = new Set()

	$scope.find('.field-wrap.field-slider, .number-wrap.field-slider').each(function () {
		wraps.add(this)
	})

	$scope.find('input[type="number"].field-slider').each(function () {
		const $input = $(this)
		const $fieldWrap = $input.closest('.field-wrap, .number-wrap')
		if (!$fieldWrap.length) {
			return
		}

		$fieldWrap.addClass('field-slider')
		copyModifierClasses($input, $fieldWrap)
		wraps.add($fieldWrap[0])
	})

	$scope.find('.nf-field-container.field-slider').each(function () {
		const $fieldWrap = $(this).find('.field-wrap, .number-wrap').first()
		if ($fieldWrap.length) {
			$fieldWrap.addClass('field-slider')
			wraps.add($fieldWrap[0])
		}
	})

	return Array.from(wraps).map((el) => $(el))
}

const parseFieldLimits = ($number) => {
	const min = parseFloat($number.attr('min'))
	const max = parseFloat($number.attr('max'))
	const step = parseFloat($number.attr('step'))

	return {
		minVal: Number.isFinite(min) ? min : 1,
		maxVal: Number.isFinite(max) ? max : 500,
		step: Number.isFinite(step) && step > 0 ? step : 1
	}
}

const enhanceFieldSlider = ($fieldWrap) => {
	const $number = $fieldWrap.find('input[type="number"]').first()
	if (!$number.length) {
		return
	}

	if ($fieldWrap.data('sliderReady') && $fieldWrap.find('.form-slider__range').length) {
		return
	}

	$fieldWrap.find('.form-slider').remove()
	$fieldWrap.data('sliderReady', true)
	$fieldWrap.addClass('field-slider--enhanced')

	const { minVal, maxVal, step } = parseFieldLimits($number)
	let val = parseFloat($number.val())

	if (!Number.isFinite(val) || val < minVal) {
		val = minVal
	}

	val = Math.min(maxVal, Math.max(minVal, val))

	const $element = $fieldWrap.find('.nf-field-element').first()
	const labelText = $fieldWrap.find('.nf-field-label label').text().trim()
	const $sliderUi = $(`
		<div class="form-slider">
			<div class="form-slider__row">
				<div class="form-slider__wrap">
					<input type="range" class="form-slider__range" />
				</div>
				<output class="form-slider__value"></output>
			</div>
		</div>
	`)

	const $range = $sliderUi.find('.form-slider__range')
	const $output = $sliderUi.find('.form-slider__value')

	$range.attr({
		min: minVal,
		max: maxVal,
		step,
		value: val,
		'aria-valuemin': minVal,
		'aria-valuemax': maxVal,
		'aria-valuenow': val,
		'aria-label': labelText || 'Slider value'
	})

	$number.addClass('form-slider__input')
	$element.prepend($sliderUi)

	const syncOutput = (nextVal) => {
		$output.text(String(nextVal))
		$range.val(nextVal)
		$range.attr('aria-valuenow', String(nextVal))
		updateRangeStyle($range)
	}

	syncOutput(val)
	syncNumberFieldValue($number, val)

	$range.on('input', function () {
		const nextVal = parseFloat($(this).val())
		syncOutput(nextVal)
	})

	$range.on('change', function () {
		const nextVal = parseFloat($(this).val())
		syncNumberFieldValue($number, nextVal)
		syncOutput(nextVal)
	})
}

const initFormNumberSliders = (context) => {
	const $scope = context ? $(context) : $(document)

	collectFieldWraps($scope).forEach(($fieldWrap) => {
		enhanceFieldSlider($fieldWrap)
	})
}

let debounceTimer = null

const scheduleInitFormNumberSliders = (context) => {
	clearTimeout(debounceTimer)
	debounceTimer = setTimeout(() => {
		initFormNumberSliders(context)
	}, 50)
}

const shouldReinitFromMutations = (mutations) => {
	return mutations.some((mutation) => {
		return Array.from(mutation.addedNodes).some((node) => {
			if (node.nodeType !== 1) {
				return false
			}

			const el = node
			return (
				(el.matches && el.matches('.field-wrap.field-slider, .number-wrap.field-slider')) ||
				(el.querySelector && el.querySelector('.field-wrap.field-slider, .number-wrap.field-slider'))
			)
		})
	})
}

const observeNinjaFormRoots = () => {
	if (typeof MutationObserver === 'undefined') {
		return
	}

	const observer = new MutationObserver((mutations) => {
		if (!shouldReinitFromMutations(mutations)) {
			return
		}

		scheduleInitFormNumberSliders()
	})

	document.querySelectorAll('.nf-form-cont, .form').forEach((root) => {
		observer.observe(root, { childList: true, subtree: true })
	})
}

const bindFormSliderSubmitSync = () => {
	$(document).on(
		'click',
		'.nf-form-cont .submit-container input[type="button"], .nf-form-cont .submit-container input[type="submit"]',
		function () {
			syncFormNumberSlidersInScope($(this).closest('.nf-form-cont'))
		}
	)

	$(document).on('submit', '.nf-form-cont form', function () {
		syncFormNumberSlidersInScope($(this).closest('.nf-form-cont'))
	})
}

const initFormNumberSliderHooks = () => {
	window.__initRoiFormSliders = (context) => {
		scheduleInitFormNumberSliders(context)
	}

	window.__syncFormNumberSliders = syncFormNumberSlidersInScope

	scheduleInitFormNumberSliders()
	setTimeout(() => scheduleInitFormNumberSliders(), 300)
	setTimeout(() => scheduleInitFormNumberSliders(), 1000)

	$(document).on('nfFormReady nfFormsReady', function (event, layoutView) {
		if (layoutView && layoutView.el) {
			scheduleInitFormNumberSliders(layoutView.el)
		} else {
			scheduleInitFormNumberSliders()
		}
	})

	bindFormSliderSubmitSync()
	observeNinjaFormRoots()
}

export { initFormNumberSliderHooks, syncFormNumberSlidersInScope, syncNumberFieldValue as syncNfFieldValue }
